import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-cream tech-grid-light py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-120" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-121" data-mp="1dy1o32dpwry5">
        <div className="text-center" data-id="element-122" data-mp="2bjywu82apiww">
          <span className="inline-flex items-center gap-2 rounded-md bg-forest px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-sageGlow" data-id="element-123" data-mp="2bixo4a8r58ic">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="21lsy1zbscsw9" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-125" data-mp="1wnhprt152qg5">
            The {totalVolumes} Comprehensive Volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-126" data-mp="l7t20zg29nea">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-line bg-panel shadow-card" data-id="element-127" data-mp="1iw0c4ez7sagi" data-mpi={index}>
                <div className="flex items-center gap-4 bg-forest px-6 py-5" data-id="element-128" data-mp="14v7hzvctrhdx">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-earth text-white" data-id="element-129" data-mp="14xai587oyqwd">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-130" data-mp="v5edtff0i4jp" />
                  </span>
                  <div data-id="element-131" data-mp="h64zymea3miw">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-sageGlow" data-id="element-132" data-mp="h5mvj2hgq1zw">
                      Volume {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-133" data-mp="2ntvl8ji8trtv">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-134" data-mp="2j1uete7ravbr">
                  <p className="font-semibold text-forestSoft" data-id="element-135" data-mp="2e3svcs6f4tzr">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-muted" data-id="element-136" data-mp="295ixuax81haz">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-137" data-mp="36qnbxe04797y">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-138" data-mp="31s3plchlzvf2">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-139" data-mp="2st8k62me2pct">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-140" data-mp="2svl1cdkbovot" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-earth bg-earthSoft p-4 text-sm leading-relaxed text-ink" data-id="element-141" data-mp="3t1ezr0lu0ue9">
                    <b className="font-extrabold text-earthDark" data-id="element-142" data-mp="x49i6iw3jg6">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-forest px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-143" data-mp="ao7c5crgw6hk">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-sageGlow" data-id="element-144" data-mp="kllg4cw7f2sz">Main collection</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-145" data-mp="onghtii1ri7a">
            {totalVolumes} comprehensive volumes <span className="mx-2 text-gold" data-id="element-146" data-mp="tmjkwxegvecm">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}